import mock from "src/utils/mock";

mock.onPost("/api/trainingRequests/add").reply(request => {
  console.log("Got training request:");
  console.log(JSON.stringify(request.data));

  return [200, {}];
});
